import { SUBGRADE_LABEL } from "../../../../../../../constants/Dictionary";
import {
  ManagementTable,
  ManagementTableHeader,
} from "../../../../../Components/Table/ManagementTable";
import { SubgradeConfigItem } from "../../../../../../../types/api/configurations.type";
import { FieldValues } from "react-hook-form";
import { compareDataGeneric } from "../../../../../../../utils/comparing.utils";
import {
  useManageSubgrades,
  useUpdateManageSubgrades,
} from "../../../../../../../hooks/management/CmSheet/InternalGrade/useManagementSubgrades.hooks";

type ManageSubgradesProps = {
  setDisableFilters: (x: boolean) => void;
  configYear: number;
};

export const ManageSubgrades = ({
  setDisableFilters,
  configYear,
}: ManageSubgradesProps) => {
  const { data, isFetching } = useManageSubgrades(configYear);
  const { mutate: updateSubgrades, isPending: isUpdatingSubgrades } =
    useUpdateManageSubgrades();

  const subgradesColumns: ManagementTableHeader[] = [
    {
      key: "name",
      label: SUBGRADE_LABEL,
      width: 100,
      type: "text",
    },
  ];

  const onSave = async (formData: FieldValues) => {
    const compareData = (formData.items as SubgradeConfigItem[]).map(
      (item, index) => ({
        ...item,
        position: index + 1,
      }),
    );
    const result = compareDataGeneric<SubgradeConfigItem>(data!, compareData);
    updateSubgrades(result);
  };

  return (
    <ManagementTable<SubgradeConfigItem>
      data={data ?? []}
      keyItem={"name"}
      draggableRows={true}
      headers={subgradesColumns}
      itemLabel={SUBGRADE_LABEL}
      toggleFilters={setDisableFilters}
      onSave={onSave}
      loading={isFetching || isUpdatingSubgrades}
    />
  );
};
